import { FC, Fragment } from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Switch } from "../core/Switch";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { HeatIcon } from "../core/icons/Icons";
import { useStyles } from "../../useStyles";
import { InputLabel } from "@material-ui/core";
import { NumberInput } from "../core/NumberField";

export const ElectricHeatingSystemForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } =
        useFormModel<ChangeNames.NEW_CONNECTION_ELECTRIC_HEATING_SYSTEM_V2>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<HeatIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Speicherheizung, Direktheizung
                        </p>
                    </Fragment>
                }
                useSwitch={
                    <Switch
                        checked={values.newConnectionElectricHeatingSystemV2.value.installed}
                        {...getFieldProps("newConnectionElectricHeatingSystemV2.value.installed")}
                        onChange={(ev, checked) =>
                            setValues(values => {
                                values.newConnectionElectricHeatingSystemV2.value.installed = checked;
                                values.newConnectionElectricHeatingSystemV2.value.demand.amount = checked
                                    ? 0
                                    : null;
                            })
                        }
                    />
                }
                detailCondition={values.newConnectionElectricHeatingSystemV2.value.installed}
                detail={
                    <Fragment>
                        <InputLabel
                            className={classes.labledTextfieldLabel}
                            style={{ marginTop: 0 }}
                        >
                            Summe der Leistung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={
                                values.newConnectionElectricHeatingSystemV2.value.demand.precision
                            }
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.newConnectionElectricHeatingSystemV2.value.demand.unit}
                            value={values.newConnectionElectricHeatingSystemV2.value.demand.amount || ""}
                            placeholder="0"
                            onValueChange={v =>
                                setValues(values => {
                                    values.newConnectionElectricHeatingSystemV2.value.demand.amount =
                                        v.floatValue || null;
                                })
                            }
                            error={values.newConnectionElectricHeatingSystemV2.error != null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
